import { createAsyncThunk } from "@reduxjs/toolkit";
import { feesApi } from "../../api/requests";
import { RootState } from "../store";
import { ActionTypes } from "./types";
import { transformAmountHistory, transformDescriptionHistory, transformSubFees } from "../../helpers/tabletree";

export const getFeeDetailsThunk = createAsyncThunk<any, { feeCodeQuery: string }, { state: RootState }>(ActionTypes.FETCH_FEE_DETAILS, async ({ feeCodeQuery }, thunkAPI) => {
    try {
        const { currency } = thunkAPI.getState().table.filters;
        const { language } = thunkAPI.getState().settings;

        const res = await feesApi.getFeeDetails({ language, currency: currency, feeCode: feeCodeQuery });

        if (!res.ok) {
            throw new Error('Failed to fetch Fees');
        }

        const data = await res.json();

        const details = data.feeDetail;

        const { feeCode, feeDescription, subFee, amountHistory, descriptionHistory } = details;

        return { feeCode, feeDescription, subFee: transformSubFees(subFee), descriptionHistory: transformDescriptionHistory(descriptionHistory), amountHistory: transformAmountHistory(amountHistory) };
    } catch (err) {
        return thunkAPI.rejectWithValue('Failed to fetch Fees');
    }
})